import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportUrls } from '@custom/Utils/constants/apiUrls';

interface UpdateReportResponse {
  result: any;
  status: string;
  msg?: string;
  data?: any;
}

interface UpdateReportPayload {
  _id: string;
  _rev?: string;
  uhid: string;
  name: string;
  age: string;
  gender: string;
  date: string;
  time: string;
  patientId: string;
  reportName: string;
  findings: string;
  impression: string;
  comparison: string;
  clinicalInformation: string;
  procedureInformation: string;
  status: string;
}

const updatedReport = createAsyncThunk<UpdateReportResponse, UpdateReportPayload>(
  'updatedReport',
  async (body: UpdateReportPayload) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = _reportUrls.updateReport;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Failed to update report');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default updatedReport;
